import script from "./NotifyView.vue?vue&type=script&setup=true&lang=ts"
export * from "./NotifyView.vue?vue&type=script&setup=true&lang=ts"

import "./NotifyView.vue?vue&type=style&index=0&id=0144f12a&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.22_vue@3.5.22_typescript@5.9.3__webpack@5.102.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0144f12a"]])

export default __exports__